import * as PropTypes from 'prop-types';
import * as React from 'react';
import { CURRENCY_CODES } from '../../../shared/constants';
import CountryCodeInput from './country_code_input';

const ACCOUNT_INPUT_LENGTH = 17;

class EUBankFields extends React.Component {
  infoStoredSecurely() {
    if (this.props.dashboardView) {
      return false;
    }
    const lockIcon = '<i class="fa fa-lock"></i>';
    const text = I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.bankAccountFields.infoStoredSecurelyHtml', { lockIcon });

    return (
      <p
        className="fine-print mb-half"
        dangerouslySetInnerHTML={{ __html: text }}
      />
    );
  }

  formattedNameForCurrency() {
    return this.props.currencies[0].name;
  }

  render() {
    return (
      <div>
        {this.infoStoredSecurely()}
        <div className="g-container mb-1">
          <div className="g-col-6 g-col-mobile-12">
            <label>
              {I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.bankAccountFields.nameOnAccount')}
            </label>
            <input
              className="string required wide mb-0"
              autoFocus="on"
              type="text"
              name={this.props.nameForField('name_on_account')}
            />
          </div>
        </div>
        <div className="mb-1">
          <div className="g-container">
            <CountryCodeInput
              countryCode={this.props.bankCountry}
              countryCodeOptions={this.props.countryCodeOptions}
              nameForField={fieldName => this.props.nameForField(fieldName)}
              onCountryChange={countryCode => this.props.onCountryChange(countryCode)}
            />
            <div className="g-col-6">
              <label className="string required">
                {I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.bankAccountFields.currencyInput.label')}
              </label>
              <input
                type="hidden"
                name={this.props.nameForField('currency')}
                value={CURRENCY_CODES.EUR}
              />
              <div>{this.formattedNameForCurrency()}</div>
            </div>
          </div>
        </div>

        <div className="g-container">
          <div className="g-col-6 g-col-mobile-12">
            <label className="string required">
              {I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.bankAccountFields.bicNumber')}
            </label>
            <input
              className="string required wide"
              maxLength={ACCOUNT_INPUT_LENGTH}
              type="text"
              name={this.props.nameForField('bic_number')}
            />
          </div>

          <div className="g-col-6 g-col-mobile-12">
            <label className="string required">
              {I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.bankAccountFields.iban')}
            </label>
            <input
              className="string required wide"
              maxLength={ACCOUNT_INPUT_LENGTH}
              type="text"
              name={this.props.nameForField('bank_account_number')}
            />
          </div>
        </div>
      </div>
    );
  }
}

EUBankFields.propTypes = {
  countryCodeOptions: PropTypes.array.isRequired,
  nameForField: PropTypes.func.isRequired,
  onCountryChange: PropTypes.func.isRequired,
  currencies: PropTypes.array.isRequired,
  dashboardView: PropTypes.bool.isRequired,
  bankCountry: PropTypes.string.isRequired,
};

export default EUBankFields;



// WEBPACK FOOTER //
// ./javascripts/components/shop/direct_checkout_profile/bank_account_fields/eu_bank_fields.jsx